// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Zozd0","info":"Note_info__3TxnK","note":"Note_note__1W1mz","actions":"Note_actions__3b7eq"};